import {MAP_OPTIONS} from "@/config/mapOptions";

const state = {
    activeLocation: "Edinburgh",
    mapOptions: MAP_OPTIONS,
    center: {
        lat: 55.949596,
        lng: -3.216283,
    }
}

const getters = {
    //
}

const mutations = {
    setCenter(state, center) {
        state.center = center
    },
    setLocation(state, location) {
        state.activeLocation = location
    }
}

const actions = {
    //
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}